import React, { useEffect, useState } from 'react';
import { IntegratedLogo } from './IntegratedLogo';
export const LoadingCurtain = () => {
  const [phase, setPhase] = useState<'visible' | 'fading' | 'gone'>('visible');
  useEffect(() => {
    const fadeTimer = setTimeout(() => setPhase('fading'), 1800);
    const removeTimer = setTimeout(() => setPhase('gone'), 2600);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(removeTimer);
    };
  }, []);
  if (phase === 'gone') return null;
  return <div className={`fixed inset-0 z-[9999] flex items-center justify-center transition-opacity duration-[800ms] ease-out pointer-events-none ${phase === 'fading' ? 'opacity-0' : 'opacity-100'}`} style={{
    background: 'radial-gradient(ellipse at center, #FAF5EA 0%, #F5EFE0 60%, #EFE5D0 100%)'
  }} aria-hidden="true" data-id="element-341">
      {/* Soft warm halo behind the logo */}
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none" style={{
      width: '600px',
      height: '600px',
      background: 'radial-gradient(circle at center, rgba(232, 201, 136, 0.35) 0%, rgba(212, 180, 131, 0.15) 40%, transparent 75%)',
      filter: 'blur(30px)'
    }} data-id="element-342" />

      {/* Bokeh particles */}
      <div className="absolute top-[20%] left-[18%] w-3 h-3 rounded-full bg-gold-300/40 blur-[2px] animate-pulse" style={{
      animationDuration: '3s'
    }} data-id="element-343" />
      <div className="absolute top-[35%] right-[20%] w-4 h-4 rounded-full bg-gold-400/30 blur-md animate-pulse" style={{
      animationDuration: '4s'
    }} data-id="element-344" />
      <div className="absolute bottom-[28%] left-[25%] w-2 h-2 rounded-full bg-white/60 blur-[1px] animate-pulse" style={{
      animationDuration: '2.5s'
    }} data-id="element-345" />
      <div className="absolute bottom-[35%] right-[28%] w-3 h-3 rounded-full bg-gold-300/35 blur-sm animate-pulse" style={{
      animationDuration: '3.5s'
    }} data-id="element-346" />
      <div className="absolute top-[60%] left-[12%] w-2 h-2 rounded-full bg-white/50 blur-[1px] animate-pulse" style={{
      animationDuration: '3s'
    }} data-id="element-347" />

      {/* Logo with elegant reveal animation */}
      <div className="relative z-10 flex flex-col items-center" style={{
      animation: 'curtain-logo-reveal 1.4s ease-out forwards'
    }} data-id="element-348">
        <IntegratedLogo size={180} data-id="element-349" />

        {/* Thin gold flourish below the logo */}
        <div className="flex items-center justify-center gap-3 mt-8 opacity-0" style={{
        animation: 'curtain-flourish-fade 1s ease-out 0.6s forwards'
      }} data-id="element-350">
          <div className="h-px w-20 bg-gradient-to-r from-transparent via-[#C9B58A] to-[#B8A580]" data-id="element-351" />
          <div className="w-1.5 h-1.5 rotate-45" style={{
          background: 'linear-gradient(135deg, #F0E1C5, #C9B58A 60%, #B8A580)',
          boxShadow: '0 0 6px rgba(220, 200, 160, 0.6)'
        }} data-id="element-352" />
          <div className="h-px w-20 bg-gradient-to-l from-transparent via-[#C9B58A] to-[#B8A580]" data-id="element-353" />
        </div>
      </div>

      <style data-id="element-354">{`
        @keyframes curtain-logo-reveal {
          0% {
            opacity: 0;
            transform: scale(0.85);
            filter: blur(8px);
          }
          60% {
            opacity: 1;
            transform: scale(1);
            filter: blur(0);
          }
          100% {
            opacity: 1;
            transform: scale(1);
            filter: blur(0);
          }
        }
        @keyframes curtain-flourish-fade {
          0% { opacity: 0; transform: translateY(8px); }
          100% { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>;
};